import { useLocalStorage } from '@/hooks/local-storage';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useRouter } from 'next/router';
import React from 'react';
import { sortBy } from 'lodash';

export const LS_SELECTED_PID_KEY = 'selected-pid';

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));

interface AppProfileSelectProps {
  profiles: {
    id: string;
    pid: string;
    organization?: {
      name: string;
    } | null;
  }[];
  value: string;
  native?: boolean;
}

export default function AppProfileSelect({
  profiles,
  value,
  native = false,
}: AppProfileSelectProps): JSX.Element {
  const classes = useStyles();
  const router = useRouter();
  const localStorage = useLocalStorage();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const pid = event.target.value as string;
    localStorage.setUserItem(LS_SELECTED_PID_KEY, pid);
    router.push(`/p/${pid}`);
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <Select
        classes={{ root: classes.select }}
        value={value}
        onChange={handleChange}
        disabled={profiles.length < 2}
        native={native}
      >
        {sortBy(profiles, 'organization.name').map(({ pid, organization }) =>
          native ? (
            <option key={pid} value={pid}>
              {organization?.name ?? `Profile[${pid}]`}
            </option>
          ) : (
            <MenuItem key={pid} value={pid}>
              {organization?.name ?? `Profile[${pid}]`}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
}
